<script>
import _ from "lodash";

export default {
  data() {
    return {
      show: false,
      filters: this.fresh()
    };
  },

  methods: {
    onSubmit() {
      this.$emit("filter", _.clone(this.filters));

      this.filters = this.fresh();

      this.$refs.dropdown.toggle();
    }
  }
};
</script>
